import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-53d142f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]




export default /*#__PURE__*/_defineComponent({
  __name: 'CustomPic',
  props: {
  picturePath: {
    type: String,
    default: () => "",
  },
  height: {
    type: String,
    default: () => "100%",
  },
  fit: {
    type: Boolean,
    default: true,
  },
  auto: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {



function getImgUrl(pic: string) {
  return require("@/assets/" + pic);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("img", {
    class: _normalizeClass(['image', __props.fit ? 'cssFit' : '', __props.auto ? 'cssAuto' : '']),
    style: _normalizeStyle(`height: ${__props.height};`),
    src: getImgUrl(__props.picturePath)
  }, null, 14, _hoisted_1))
}
}

})